import { useRef, useCallback, EventHandler, MouseEvent, DependencyList } from 'react';

export function useDoubleClick<T>(
    onDoubleClick: EventHandler<MouseEvent<T>>,
    deps: DependencyList = [],
): EventHandler<MouseEvent<T>> {
    const times = useRef(0);
    const timer = useRef<number | undefined>(undefined);

    return useCallback((event: MouseEvent<T>) => {
        clearTimeout(timer.current);

        // @ts-ignore
        timer.current = setTimeout(() => {
            times.current = 0;
        }, 200);

        times.current += 1;

        if (times.current === 2) {
            onDoubleClick(event);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
